import React, { useState } from 'react';
import { colors } from '../../theme';
import { deleteScan } from '../../services/bodyScanService';
import { Button, mono, fmtDay, fmtNum, muscleKindLabel } from './parts';

// One scan (SPEC screen 09): the three numbers, date, machine, who entered it and when, how; Edit and a
// confirmed Delete (undoable for 30 days) for those who may correct it.
export default function ScanDetail({ scan, whoEntered, mayCorrect, onEdit, onDeleted }) {
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const rows = [
    ['Weight', scan.weight_kg, 'kg'],
    ['Body fat', scan.body_fat_pct, '%'],
    [scan.muscle_kind ? muscleKindLabel(scan.muscle_kind) : 'Muscle', scan.muscle_kg, 'kg'],
  ];
  const remove = async () => {
    setBusy(true);
    setError(null);
    try { onDeleted(await deleteScan(scan)); } catch (e) { setError(e.message); setBusy(false); }
  };
  return (
    <div>
      {rows.map(([label, v, unit]) => (
        <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '16px 0', borderBottom: `1px solid ${colors.border}` }}>
          <span style={{ fontSize: 15 }}>{label}</span>
          <span><span style={{ ...mono, fontSize: 28, fontWeight: 700 }}>{fmtNum(v)}</span> <span style={{ ...mono, fontSize: 12, color: colors.textMuted }}>{v === null ? '' : unit}</span></span>
        </div>
      ))}
      <dl style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 12, fontSize: 12, margin: '16px 0', color: colors.textMuted }}>
        <dt>Date</dt><dd style={{ margin: 0, textAlign: 'right', color: colors.text }}>{fmtDay(scan.measured_on, true)}</dd>
        <dt>Machine</dt><dd style={{ margin: 0, textAlign: 'right', color: colors.text }}>{scan.machine}</dd>
        <dt>Entered by</dt><dd style={{ margin: 0, textAlign: 'right', color: colors.text }}>{whoEntered(scan)}, {new Date(scan.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}</dd>
        <dt>How</dt><dd style={{ margin: 0, textAlign: 'right', color: colors.text }}>{scan.entry_method === 'photo_confirmed' ? 'Read from a photo, checked' : 'Typed'}</dd>
      </dl>
      {error && <div role="alert" style={{ fontSize: 12, marginBottom: 12 }}>{error}</div>}
      {mayCorrect && !confirming && (
        <div style={{ display: 'grid', gap: 4 }}>
          <Button onClick={onEdit}>Edit</Button>
          <Button kind="quiet" onClick={() => setConfirming(true)}>Delete</Button>
        </div>
      )}
      {mayCorrect && confirming && (
        <div style={{ display: 'grid', gap: 8 }}>
          <div style={{ fontSize: 13, lineHeight: 1.5 }}>Delete this scan? It can be put back for 30 days.</div>
          <Button onClick={remove} disabled={busy}>{busy ? 'Deleting…' : 'Yes, delete it'}</Button>
          <Button kind="quiet" onClick={() => setConfirming(false)}>Keep it</Button>
        </div>
      )}
    </div>
  );
}
